import {createContext, useContext} from 'react';

import {TemplateSerializedType} from 'sweet-types';

export const TemplateContext = createContext<TemplateSerializedType | null>(
  null
);

export function useTemplate() {
  const context = useContext(TemplateContext);
  if (context == null) {
    throw new Error(
      'useTemplate must be used within a TemplateContext.Provider'
    );
  }
  return context;
}
